/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OtelDestinationHeader,
  OtelDestinationHeader$inboundSchema,
} from "./oteldestinationheader.js";

/**
 * OTEL-specific destination configuration.
 */
export type OtelDestination = {
  /**
   * OTEL collector endpoint URL. Transport-specific paths may be appended during delivery.
   */
  endpointUrl: string;
  /**
   * Configured HTTP header names. Header values are never returned.
   */
  headers: Array<OtelDestinationHeader>;
};

/** @internal */
export const OtelDestination$inboundSchema: z.ZodMiniType<
  OtelDestination,
  unknown
> = z.pipe(
  z.object({
    endpoint_url: z.string(),
    headers: z.array(OtelDestinationHeader$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "endpoint_url": "endpointUrl",
    });
  }),
);

export function otelDestinationFromJSON(
  jsonString: string,
): SafeParseResult<OtelDestination, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OtelDestination$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OtelDestination' from JSON`,
  );
}
